/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1439
 */

var r = require(/* 2507 */"./2507/index")
var i = require(/* 538 */"../../../../2467/538")
module.exports = function e(t, n, o, a, s) {
  return t === n || (null == t || null == n || !i(t) && !i(n) ? t !== t && n !== n : r(t, n, o, a, e, s))
}
